import axiosClient from './axiosClient';
import { ClientOrgModel } from '../Models/clientOrgModel';

const clientOrgService = {
  getAll: () => {
    return axiosClient.get('/ClientOrganization')
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("GET /ClientOrganization returned 404. Falling back to GET /clientOrganizations...");
          return axiosClient.get('/clientOrganizations');
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const rawList = res?.data?.data || res?.data || [];
        const mappedList = (Array.isArray(rawList) ? rawList : []).map(ClientOrgModel.toFrontend);
        return {
          data: mappedList,
        };
      });
  },

  getById: (clientOrgID) => {
    return axiosClient.get(`/ClientOrganization/${clientOrgID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`GET /ClientOrganization/${clientOrgID} returned 404. Falling back to GET /clientOrganizations/${clientOrgID}...`);
          return axiosClient.get(`/clientOrganizations/${clientOrgID}`);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ClientOrgModel.toFrontend(raw),
        };
      });
  },

  create: (payload) => {
    const body = ClientOrgModel.toBackend(payload);
    body.clientOrgId = 0;

    return axiosClient.post('/ClientOrganization', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("POST /ClientOrganization returned 404. Falling back to POST /clientOrganizations...");
          return axiosClient.post('/clientOrganizations', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ClientOrgModel.toFrontend(raw),
        };
      });
  },

  update: (clientOrgID, payload) => {
    const body = ClientOrgModel.toBackend({ ...payload, clientOrgID });

    return axiosClient.put('/ClientOrganization', body)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn("PUT /ClientOrganization returned 404. Falling back to PUT /clientOrganizations...");
          return axiosClient.put('/clientOrganizations', body);
        }
        return Promise.reject(err);
      })
      .then((res) => {
        const raw = res?.data?.data || res?.data;
        return {
          data: ClientOrgModel.toFrontend(raw),
        };
      });
  },

  remove: (clientOrgID) => {
    return axiosClient.delete(`/ClientOrganization/${clientOrgID}`)
      .catch((err) => {
        if (err?.response?.status === 404) {
          console.warn(`DELETE /ClientOrganization/${clientOrgID} returned 404. Falling back to DELETE /clientOrganizations/${clientOrgID}...`);
          return axiosClient.delete(`/clientOrganizations/${clientOrgID}`);
        }
        return Promise.reject(err);
      });
  },
};

export default clientOrgService;
